import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom'
import './Footer.css';
import FBIcon from '../../assets/icons/icon_fb.svg';
import YTIcon from '../../assets/icons/icon_yb.svg';
import TWIcon from '../../assets/icons/icon_tw.svg';
import INIcon from '../../assets/icons/icon_in.svg';
import SLIcon from '../../assets/icons/icon_sl.svg';
import LNIcon from '../../assets/icons/icon_ln.svg';

const footerItems = [
  {
    id: 'get-involved',
    label: 'Get Involved',
    items: [
      {
        id: 'become-a-sponsor',
        label: 'Become a sponsor',
      },
      {
        id: 'apply-to-speak',
        label: 'Apply to speak',
      },
      {
        id: 'apply-for-media-pass',
        label: 'apply for media pass',
      },
    ]
  },
  {
    id: 'resources',
    label: 'Resources',
    items: [
      {
        id: 'blog',
        label: 'Blog',
      },
      {
        id: 'video-portal',
        label: 'Video Portal',
      },
      {
        id: 'newsletter',
        label: 'Newsletter',
      },
      {
        id: 'leadership-counsil',
        label: 'Leadership Counsil',
      },
    ]
  },
  {
    id: 'support',
    label: 'Support',
    items: [
      {
        id: 'contact-us',
        label: 'Contact Us',
      },
      {
        id: 'events-faq',
        label: 'Events FAQ',
      },
      {
        id: 'privacy-policy',
        label: 'Privacy Policy',
      },
      {
        id: 'terms-of-use',
        label: 'Terms of Use',
      },
    ]
  },
  {
    id: 'ai4-2014',
    label: 'AI4 2024',
    items: [
      {
        id: 'agenda',
        label: 'Agenda',
      },
      {
        id: 'speakers',
        label: 'Speakers',
      },
      {
        id: 'sponsors',
        label: 'Sponsors',
      },
      {
        id: 'book-your-hotel',
        label: 'Book your Hotel',
      },
    ]
  },
];

const socialItems = [
  {
    id: 'facebook',
    icon: FBIcon,
    link: '',
  },
  {
    id: 'youtube',
    icon: YTIcon,
    link: '',
  },
  {
    id: 'twitter',
    icon: TWIcon,
    link: '',
  },
  {
    id: 'instagram',
    icon: INIcon,
    link: '',
  },
  {
    id: 'slack',
    icon: SLIcon,
    link: '',
  },
  {
    id: 'linkedin',
    icon: LNIcon,
    link: '',
  },
]

const Footer = () => {
  return <div className="footer">
    <div className="footer-row">
      {
        footerItems.map(item => (
          <div key={item.id}>
            <p className="footer-title">{item.label}</p>
            <div className="footer-column">
            {
              item.items.map(subItem => (
                <Link
                  key={subItem.id}
                  to={`/${subItem.id}`}
                  className={clsx('footer-link', item.id === 'get-involved' && 'first-column-link')}
                >
                  {subItem.label}
                </Link>
              ))
            }
            </div>
          </div>
        ))

      }
      <div>
        <div className={clsx('row', 'fooer-social-row')}>
        {
          socialItems.map(item => (
            <Link to={`/${item.link}`} className="footer-social-link" key={item.id}>
              <img src={item.icon} alt="icon" />
            </Link>
          ))
        }
        </div>
        <p className="footer-text">
          Help Support Diversity & Inclusion: Ai4 donates to <a href="https://www.blackgirlscode.com/">Black Girls Code</a><span>.</span><br />
          We hope you'll consider donating too.
        </p>

      </div>
    </div>
    <p className="trademark">
      Copyright© 2023 Ai4 LLC, All Rights Reserved
    </p>
  </div>;
}

export default Footer;
